import React, { Fragment } from 'react';
import SignInOrRegister from '../signin-or-register/SignInOrRegister';
import { OutageSummary } from '../outage-summary';
import { OutageActions } from '../outage-actions';
import { ViewByCountyZipcode } from '../viewby-county-zip';
import { OutageFAQ } from '../outage-faq';
import { OutageSummaryFooter } from '../outage-summary-footer';
import { GetMobileApp } from '../get-mobile-app';
import {
  OutageMarkerView,
  useOutageLeftPanelState,
} from '../../providers/OutageLeftPanelStateProvider';
import { ReportedOutageInfo } from '../reported-outage-info';
import { useIsMobile } from '../../../../util/style-utils';

export default function PublicLeftPanelContent() {
  const { panelOpen, outageMarkerView } = useOutageLeftPanelState();
  const isMobile = useIsMobile();
  return (
    <Fragment>
      {(!isMobile || outageMarkerView === undefined) && <SignInOrRegister />}

      {outageMarkerView ? <ReportedOutageInfo /> : <OutageSummary />}
      <OutageActions />
      {!outageMarkerView && <ViewByCountyZipcode />}
      <OutageFAQ />
      {panelOpen && (
        <>
          <GetMobileApp />
          {outageMarkerView && <OutageSummaryFooter />}
        </>
      )}
    </Fragment>
  );
}
